import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=aa466f2a&scoped=true&"
import script from "./FooterPage.vue?vue&type=script&lang=js&"
export * from "./FooterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa466f2a",
  null
  
)

export default component.exports